import { useEffect, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
const BlogList = lazy(() => import("./pages/BlogList"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const DentalImplantsLucknow = lazy(() => import("./pages/DentalImplantsLucknow"));
const PeriodontistLucknow = lazy(() => import("./pages/PeriodontistLucknow"));
const GumTreatmentLucknow = lazy(() => import("./pages/GumTreatmentLucknow"));
const RootCanalTreatmentLucknow = lazy(() => import("./pages/RootCanalTreatmentLucknow"));
const TeethWhiteningLucknow = lazy(() => import("./pages/TeethWhiteningLucknow"));
const ClearAlignersLucknow = lazy(() => import("./pages/ClearAlignersLucknow"));
const NotFound = lazy(() => import("./pages/NotFound"));
import ErrorBoundary from "./pages/ErrorBoundary";
import CustomCursor from "./components/CustomCursor";
import { Toaster } from "sonner";

function App() {
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("in");
      });
    }, { threshold: 0.12 });
    const els = document.querySelectorAll(".reveal");
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="App">
      <CustomCursor />
      <Toaster position="top-center" richColors />
      <ErrorBoundary>
        <BrowserRouter>
          <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/dental-implants-lucknow/" element={<DentalImplantsLucknow />} />
            <Route path="/periodontist-lucknow/" element={<PeriodontistLucknow />} />
            <Route path="/gum-treatment-lucknow/" element={<GumTreatmentLucknow />} />
            <Route path="/root-canal-treatment-lucknow/" element={<RootCanalTreatmentLucknow />} />
            <Route path="/teeth-whitening-lucknow/" element={<TeethWhiteningLucknow />} />
            <Route path="/clear-aligners-lucknow/" element={<ClearAlignersLucknow />} />
            <Route path="/500" element={<NotFound code={500} />} />
            <Route path="*" element={<NotFound code={404} />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
